import { productQuantityBreakPricingStyles } from "@insite/content-library/Components/ProductQuantityBreakPricing";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(productQuantityBreakPricingStyles, {
    viewLink: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smallest};
            color: ${getColor("primary")};
            line-height: ${TYPOGRAPHY.lineHeight.small};
        `,
    },
});
